'use client';

import { useQuery } from '@tanstack/react-query';
import { productAPI, settingAPI } from '@/lib/api';
import Link from 'next/link';
import { useState } from 'react';

export default function ProductCategories() {
  const [expandedCategory, setExpandedCategory] = useState<string | null>(null);
  const { data: categories } = useQuery({
    queryKey: ['product-categories'],
    queryFn: () => productAPI.getCategories(),
  });
  
  // 获取设置中的分类菜单标题
  const { data: settingsData } = useQuery({
    queryKey: ['settings'],
    queryFn: () => settingAPI.getAll(),
    staleTime: 5 * 60 * 1000,
  });
  
  // settingAPI.getAll() 现在直接返回 Settings 对象
  const categoriesTitle = settingsData?.product_categories_title || 'Product Categories';

  if (!categories?.data || categories.data.length === 0) {
    return (
      <div className="bg-white p-6 rounded-lg shadow-sm">
        <h4 className="text-xl font-semibold text-text-dark mb-4">Product Categories</h4>
        <div className="separator mb-4" />
        <p className="text-text-light">暂无分类</p>
      </div>
    );
  }

  const renderCategory = (category: any, level = 0) => {
    const hasChildren = category.children && category.children.length > 0;
    const isExpanded = expandedCategory === category.id;

    return (
      <li 
        key={category.id} 
        id={`menu-item-${category.id}`}
        className={`menu-item menu-item-type-taxonomy menu-item-object-products ${hasChildren ? 'menu-item-has-children' : ''}`}
        style={{ padding: 0, listStyle: 'none', margin: 0 }}
      >
        <Link
          href={`/products?category=${category.slug}`}
          className="menu-link"
          aria-expanded={hasChildren ? isExpanded : undefined}
          onClick={(e) => {
            if (hasChildren) {
              e.preventDefault();
              setExpandedCategory(isExpanded ? null : category.id);
            }
          }}
          style={{
            display: 'block',
            padding: '8px 0',
            fontFamily: 'Arial, sans-serif',
            fontSize: level === 0 ? '16px' : '14px',
            fontWeight: 400,
            color: level === 0 ? '#000000' : '#222222',
            borderBottom: level === 0 ? '1px solid rgba(159, 159, 159, 0.4)' : 'none',
            textDecoration: 'none',
            transition: 'color 0.3s'
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.color = '#D2232A';
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.color = level === 0 ? '#000000' : '#222222';
          }}
        >
          {category.name}
        </Link>
        {hasChildren && isExpanded && (
          <ul className="sub-menu" style={{ padding: 0, listStyle: 'none', margin: 0, paddingLeft: '20px' }}>
            {category.children.map((child: any) => renderCategory(child, level + 1))}
          </ul>
        )}
      </li>
    );
  };

  return (
    <>
      {/* 标题小部件 */}
      <div className="elementor-element elementor-element-87751a1 elementor-widget__width-auto elementor-widget elementor-widget-heading" data-id="87751a1" data-element_type="widget" data-widget_type="heading.default">
        <div className="elementor-widget-container">
          <h4 className="elementor-heading-title elementor-size-default">
            {categoriesTitle}
          </h4>
        </div>
      </div>

      {/* 分隔线小部件 */}
      <div className="elementor-element elementor-element-a9ecc0b elementor-widget-divider--view-line elementor-widget elementor-widget-divider" data-id="a9ecc0b" data-element_type="widget" data-widget_type="divider.default">
        <div className="elementor-widget-container">
          <div className="elementor-divider">
            <span className="elementor-divider-separator" />
          </div>
        </div>
      </div>

      {/* 菜单小部件 */}
      <div className="elementor-element elementor-element-a009b7c menu-product-categories elementor-widget elementor-widget-ucaddon_simple_list_menu" data-element_type="widget" data-widget_type="ucaddon_simple_list_menu.default">
        <div className="elementor-widget-container">
          <div id="uc_simple_list_menu_elementor_a009b7c" className="simple_list_menu" style={{ textAlign: 'left' }}>
            <ul id="menu-product-categories" className="uc-list-menu" style={{ padding: 0, listStyle: 'none', margin: 0 }}>
              {categories.data
                .filter((cat: any) => !cat.parentId)
                .map((category: any) => renderCategory(category))}
            </ul>
          </div>
        </div>
      </div>
    </>
  );
}

